<template>
	<div class="agency-application-name">
		<v-layout row>
			<h1>Wniosek ({{value}})</h1>
			<v-icon
				v-if="!readonly"
				small
				@click="renameOpen = true"
			>edit
			</v-icon>
			<egranty-input-field-popup
				:is-open.sync="renameOpen"
				:default-value="value" 
				field-type="LONG_TEXT"
				long
				label="Nowy tytuł"
				for="agency-application-new-name"
				id="agency-application-new-name"
				title="Zmień tytuł wniosku"
				@save="rename"
			></egranty-input-field-popup>
		</v-layout>
		<br>
	</div>
</template>

<script>
	import EgrantyInputFieldPopup from "../../../../genericComponents/EgrantyInputFieldPopup";

	export default {
		name: "AgencyApplicationName",
		components: {EgrantyInputFieldPopup},
		methods: {

			rename(val) {
				if (val === "" || val === undefined || val === null) {
					return;
				}
				this.$emit("input", val);
				this.renameOpen = false;
			},

		},

		data() {
			return {
				renameOpen: false,
			};
		},

		props: {
			readonly: {
				default: false
			},
			value: {},
		},
	};
</script>

<style scoped>
	.agency-application-name h1 {
		margin-left: 20px;
}
</style>
